<script>
import Fingerprint2 from 'fingerprintjs2'
import axios from 'axios'
import { mapGetters } from 'vuex'
import { eventBus } from '@/vcs/_shared/eventBus'

import QrModal from '@/vcs/_shared/modals/QrModal.vue'
import DeviceIdModal from '@/vcs/_shared/modals/DeviceIdModal.vue'

export default {
  name: 'RemoteAuthorization',
  data: function () {
    return {
      fingerprint: '',
      token: ''
    }
  },
  computed: {
    ...mapGetters({
      clientUser: 'getClientUser'
    })
  },
  mounted() {
    window.localStorage.getItem('device_id') ? this.$router.push('/') : null
    this.generateFingerprintAndRemoteSignIn()
    eventBus.$on('decode-auth-qr', this.redirectToQrPage)
  },
  beforeDestroy() {
    eventBus.$off('decode-auth-qr')
  },
  methods: {
    generateFingerprintAndRemoteSignIn() {
      console.log('generateFingerprintAndRemoteSignIn')
      let options = {
        fonts: {
          extendedJsFonts: true
        },
        excludes: {
          // https://github.com/fingerprintjs/fingerprintjs2/wiki/Stable-components
          canvas: true,
          webgl: true,
          hardwareConcurrency: true,
          adBlock: true,
          fonts: true,
          enumerateDevices: true
        }
      }

      if (window.requestIdleCallback) {
        requestIdleCallback(() => {
          this.generateFingerprint(options)
        })
      } else {
        setTimeout(() => {
          this.generateFingerprint(options)
        }, 500)
      }
    },

    scanQR() {
      if (this.$dev) {
        // let authQr = this.authQrForDevPurposes || "";
        // let queryPart = (authQr.match(/[^\/]+$/g) || [])[0] || "";
        // let devAuthQr = `http://localhost:8080/#/${queryPart}`;

        this.redirectToQrPage('http://localhost:8080/#/qr?q=123456789---dummy-qr')
        return
      }
      console.log('scanQR')
      this.$store.commit('modal/open', {
        cmp: QrModal,
        size: 'full'
        // callback: this.redirectToQrPage
      })
    },

    redirectToQrPage(authQrUrl) {
      console.log('authQrUrl', authQrUrl)
      let authQrUrlWithClientUserQuery = ''
      if (window.localStorage.getItem('client_user')) {
        let clientUser = JSON.parse(window.localStorage.getItem('client_user'))
        authQrUrlWithClientUserQuery = `${authQrUrl}&user={"id":"${clientUser.id}","email":"${clientUser.email}","name":"${clientUser.name}","phone":"${clientUser.phone}"}`
      } else {
        authQrUrlWithClientUserQuery = authQrUrl
      }
      console.log('authQrUrlWithClientUserQuery', authQrUrlWithClientUserQuery)
      window.location.replace(authQrUrlWithClientUserQuery)
      this.generateFingerprintAndRemoteSignIn()
    },

    generateFingerprint(options) {
      // INFO: QR1
      Fingerprint2.get(options, (components) => {
        let values = components.map((component) => component.value)
        let fingerprint = Fingerprint2.x64hash128(values.join(''), 31)
        this.fingerprint = fingerprint
        this.$store.commit('setFingerprint', fingerprint)

        this.handleUserQueryIfExists(this.$route)
        let query = this.$route.query.q

        if (query) {
          let authQr = `${location.origin}/#/qr?q=${query}`
          this.remoteSignIn(authQr, fingerprint)
        }
      })
    },

    handleUserQueryIfExists(route) {
      let isUserQuery = route?.query?.user
      if (isUserQuery) {
        let clientUser = JSON.parse(route.query.user)
        window.localStorage.setItem('client_user', JSON.stringify(clientUser))
      }
    },

    remoteSignIn(authQr, fingerprint) {
      // INFO: QR3
      axios({
        method: 'post',
        url: `/auth/collection_points/remote_sign_in`,
        params: {
          authQr,
          fingerprint
        }
      })
        .then((response) => {
          this.$store.commit('setUserToken', response.data.token) // for auth
          this.$store.commit('setDeviceId', response.data.collectionPoint.id) // UUID, fake deviceID for finding CP

          this.redirectToAppAfterRemoteSignIn()
        })
        .catch((error) => {
          let authError = Object.values(error.response.data.errors)[0][0]

          if (authError == 'Incomplete credentials') {
            this.$errorHumanized(null, this.$t('error.fillPin'))
          } else if (authError == 'Bad credentials') {
            this.$errorHumanized(null, 'Nie znaleziono modułu')
          } else {
            this.$errorHumanized(error)
          }
        })
    },

    redirectToAppAfterRemoteSignIn() {
      if (!window.localStorage.getItem('client_user')) {
        this.$router.push('/')
      } else {
        this.$router.push('/delivery')
      }
    },

    setDeviceId() {
      this.$store.commit('modal/open', {
        cmp: DeviceIdModal,
        canBackrdopClose: true,
        callback: () => {
          location.reload()
        }
      })
    }
  }
}
</script>

<template lang="pug">
.page.flex-1
  .page__body.text-center
    .row
      .col
        .mb-5 {{ $t('scanQrInfo') }}
    .row.w-100
      .col
        button.btn.btn-block.btn-primary.text-white(
          type="button"
          v-ea-click="scanQR"
          :disabled="!fingerprint"
        ) {{ $t('scanQr') }}
    div
      button.btn.btn-sm.btn-text.text-light-gray(
        type="button"
        v-ea-click="setDeviceId"
        :disabled="!fingerprint"
      ) {{ $t('authorizeId') }}
</template>

<style lang="scss" scoped>
.page {
  padding: 2rem !important;
  flex: 1;
  display: flex;

  .page__body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    flex: 1;
  }
}
</style>
